var SubCategoryState;
(function (SubCategoryState) {
    SubCategoryState[SubCategoryState["Loading"] = 0] = "Loading";
    SubCategoryState[SubCategoryState["Loaded"] = 1] = "Loaded";
    SubCategoryState[SubCategoryState["Error"] = 2] = "Error";
})(SubCategoryState || (SubCategoryState = {}));
export default SubCategoryState;
//# sourceMappingURL=SubCategoryState.js.map